import type { ReactNode } from 'react'
import { Group, Text } from '@mantine/core'
import type { UserId } from '@terros/common'
import { DateTime } from 'luxon'
import { UserInfo } from './entityInfo'

export const RelativeInfo = ({ at, by, type }: { at?: number; by?: UserId; type: string }): ReactNode => {
  if (at && by)
    return (
      <Group>
        <Text>
          {type} {DateTime.fromMillis(at).toRelative()} by
        </Text>
        <UserInfo userId={by} />
      </Group>
    )
  if (at)
    return (
      <Text>
        {type} {DateTime.fromMillis(at).toRelative()}
      </Text>
    )
}
